// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__heKK3","root__inner":"Button_root__inner__YVi6Y"};